/**
 * CategoryListItem
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import { Link as LinkBase } from 'ui-component-library/base';
var SearchResultListItem = function (_a) {
    var text = _a.text, _b = _a.url, url = _b === void 0 ? '#' : _b, count = _a.count, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? LinkBase : _c, className = _a.className, htmlAttributes = __rest(_a, ["text", "url", "count", "LinkComponent", "className"]);
    var Link = LinkComponent;
    return (React.createElement("li", { className: clsx(className, 'mb-3') },
        React.createElement(Link, __assign({ to: url, className: "text-teal hover:underline" }, htmlAttributes),
            text,
            count && " (" + count + ")")));
};
export default SearchResultListItem;
